import { z } from 'zod';
import { INTRO_STATUSES } from './brain.js';

/** What the Mini App knows about the person who opened it. */
export const userPublicSchema = z.object({
  id: z.number().int().positive(),
  telegramId: z.number().int(),
  username: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  languageCode: z.string().nullable(),
  balanceCredits: z.number().int().nonnegative(),
  // Credits of the lot(s) that burn first, and when. Null when the balance is 0.
  creditsNextExpiry: z
    .object({ credits: z.number().int().positive(), expiresAt: z.string() })
    .nullable(),
  isAdmin: z.boolean(),
  // Closed testing: false until an invitation is used or an admin lets the person in.
  hasAccess: z.boolean(),
  consentRequired: z.boolean(),
  // The signature of publications and what the brain knows about the author (spec 6.3).
  author: z.object({ name: z.string().nullable(), handle: z.string().nullable(), about: z.string().nullable() }),
  introStatus: z.enum(INTRO_STATUSES),
  contentLanguage: z.string(),
});

export type UserPublic = z.infer<typeof userPublicSchema>;

/** GET /profile, POST /profile/consent */
export const profileResponseSchema = z.object({
  user: userPublicSchema,
  // https://t.me/<bot> for «отправь голосовое в чат»; null without BOT_USERNAME.
  botUrl: z.string().nullable(),
});

export type ProfileResponse = z.infer<typeof profileResponseSchema>;
